import { useTheme } from 'next-themes';
import { useTranslation } from 'react-i18next';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();
  const { t } = useTranslation('common');

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      // Rule B10: 3 is already what sonner does by default (this matches the
      // installed sonner@2.0.8 bundle's own compiled `VISIBLE_TOASTS_AMOUNT`),
      // but only by coincidence of the library's current version — declaring
      // it here makes it a decision this product owns, so a future sonner
      // upgrade cannot silently change it.
      visibleToasts={3}
      containerAriaLabel={t('notifications')}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
